import React, { useEffect } from "react";
import Card from "../components/Card";
import useGlobalStore from "../stores/globalStore";
import Loader from "../components/Loader";
import NetworkCard from "../components/NetworkCard";

function Network({ isVisible, networks }) {
  //State
  const selectedNetwork = useGlobalStore((state) => state.selectedNetwork);
  const resetSelectedBroadband = useGlobalStore((state) => state.resetSelectedBroadband);
  const resetSelectedBroadbandEquipment = useGlobalStore((state) => state.resetSelectedBroadbandEquipment);
  const resetSelectedTvEquipment = useGlobalStore((state) => state.resetSelectedTvEquipment);
  const resetSelectedSecurity = useGlobalStore((state) => state.resetSelectedSecurity);
  const resetSelectedTvPackage = useGlobalStore((state) => state.resetSelectedTvPackage);
  const resetSelectedFlexChannels = useGlobalStore((state) => state.resetSelectedFlexChannels);

  useEffect(() => {
    resetSelectedBroadband();
    resetSelectedBroadbandEquipment();
    resetSelectedTvEquipment();
    resetSelectedSecurity();
    resetSelectedTvPackage();
    resetSelectedFlexChannels();
  }, [selectedNetwork]);

  return (
    <div className={isVisible ? "tel-pt-network" : "tel-pt-network not-visible"}>
      <p className="tel-pt-view-description">Till vilket fibernät är din fastighet inkopplad?</p>
      {networks.isPending && <Loader />}
      {networks.error && <p>Something went wrong...</p>}
      {!networks.isPending &&
        networks.data &&
        networks.data.map((network: any) => {
          if (network) return <NetworkCard data={network} />;

          return null;
        })}
      {!networks.isPending && !networks.data[0] && (
        <h2 className="tel-p-form__no-product-text">Inga tillgängliga fibernät</h2>
      )}
    </div>
  );
}

export default Network;
